import {
  Disc, Lightbulb, Wind, Droplet, Wrench, Gauge, ShieldCheck, Snowflake,
  Cog, Car, Package, Zap, Droplets, Thermometer, Sparkles, KeyRound, Fuel,
  CircleDot, Fan, BatteryCharging, Armchair,
} from 'lucide-react';
import type { ComponentType } from 'react';

export type KategoriIkon = ComponentType<{ className?: string }>;

/**
 * Ikon per kategori-slug. Delas av kategoriraden i sidhuvudet, mobilmenyn
 * och fordonssidan så att samma kategori ser likadan ut överallt.
 * Första träffen vinner — de specifika mönstren står före de breda.
 */
const REGLER: Array<[RegExp, KategoriIkon]> = [
  [/^broms|abs-givare|^esp$/, Disc],
  [/^belysning|stralkastare|bakljus|blinkers|dimljus|halogen|led/, Lightbulb],
  [/^avgas|katalysator|lambda|partikelfilter/, Wind],
  [/smorjning|^olja|smorjmedel|kemiska/, Droplet],
  [/torka-spola|torkar|spolar|stralkastarrengoring/, Droplets],
  [/fjadring|spiralfjader|stotdampare|dampning/, Gauge],
  [/hjulupphangning|lankarm|krangnings|parallellstag|^hjul$|hjuldrivning|hjullager/, CircleDot],
  [/^styrning/, Wrench],
  [/kylsystem|termostat|vattenpump|kylare/, Thermometer],
  [/klimatanlaggning|aircondition|^ac\b|varme-ventilation|kupef|varme/, Snowflake],
  [/luftberedning|luftfilter|fan\b/, Fan],
  [/tandsystem|tandstift|glodsystem|motorstyrning|elektriska|elsystem|signalsystem|instrument|kommunikation|farthallare/, Zap],
  [/generator|startanordning|^batteri|startgenerator|hybrid|eldrift/, BatteryCharging],
  [/blandningsberedning|matarpump|bransle|forgasare|avgasaterforing|sekundarluft/, Fuel],
  [/topplock|vevaxel|vevhus|remmar|motorupphangning|kamrem|cylinder|svanghjul/, Cog],
  [/^koppling|kraftoverforing|vaxellada|vaxlellada/, Cog],
  [/lassystem|nyckel/, KeyRound],
  [/invandig|komfortsystem|kupeutrustning|forarhytt/, Armchair],
  [/karosseri|stotfangare|skarm|kylargrill|dorr|spegel|huv/, Car],
  [/sakerhetssystem|airbag/, ShieldCheck],
  [/verktyg|verkstad|tillbehor|standarddelar|draganordning|slapvagn/, Sparkles],
];

export function iconForCategory(slug: string): KategoriIkon {
  for (const [monster, ikon] of REGLER) if (monster.test(slug)) return ikon;
  return Package;
}
